export default __webpack_public_path__ + "static/media/meTabRightBranding.427e2982.svg";